import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Product } from 'shared/models';
import './ProductCard.css';

/**
 * A reusable card component for displaying product information
 */
const ProductCard = ({ product, index = 0, linkPath }) => {
  return (
    <Link 
      to={linkPath}
      className="item-card product-card"
      style={{ animationDelay: `${index * 0.05}s` }}
      title={product.name}
    >
      <div 
        className="card-image" 
        style={{
          backgroundColor: product.imageUrl ? 'transparent' : 'var(--primary-color)',
          backgroundImage: product.imageUrl ? `url(${product.imageUrl})` : 'none'
        }}
      >
        {!product.imageUrl && product.name.charAt(0)}
      </div>
      <div className="card-content">
        <h3 className="card-title">{product.name}</h3>
        {/* <div className="card-subtitle">{product.publisher}</div> */}
        <div className="card-meta">
          <span>{product.year}</span>
          <span className="card-tag">{product.publisher}</span>
        </div>
      </div>
    </Link>
  );
};

ProductCard.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  index: PropTypes.number,
  linkPath: PropTypes.string.isRequired
};

export default ProductCard;